import { Box, Chip, Stack } from "@mui/material";

import { PersonalizeToneOption, TONE_OPTIONS } from "./schema";

interface Props {
  selected: PersonalizeToneOption | null;
  onChange: (next: PersonalizeToneOption | null) => void;
}

export default function ToneSelector({ selected, onChange }: Props) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 1,
      }}
    >
      {TONE_OPTIONS.map((opt) => {
        const isSelected = selected === opt.id;
        return (
          <Chip
            key={opt.id}
            clickable
            label={
              <Stack direction="row" spacing={0.75} alignItems="center">
                <span>{opt.emoji}</span>
                <span>{opt.label}</span>
              </Stack>
            }
            onClick={() => onChange(isSelected ? null : opt.id)}
            sx={{
              height: 38,
              borderRadius: "8px",
              fontSize: 14,
              fontWeight: 500,
              border: "1px solid rgba(0,0,0,0.1)",
              background: isSelected ? "#8084FF" : "white",
              color: isSelected ? "white" : "#0a0a0a",
              "&:hover": {
                background: isSelected ? "#6970E8" : "#fafafa",
              },
              "& .MuiChip-label": { px: 1.5 },
            }}
          />
        );
      })}
    </Box>
  );
}
